import { render, staticRenderFns } from "./tableShippingAdmin.vue?vue&type=template&id=d32113a2&scoped=true&"
import script from "./tableShippingAdmin.vue?vue&type=script&lang=js&"
export * from "./tableShippingAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d32113a2",
  null
  
)

export default component.exports